  export function isBlocked(operacao: any, index: number, isNewGroup: boolean, talhaoAnterior: any) {
    if (operacao.status === "ExecutadaParcialmente" && operacao?.encerrada) {
      return true;
    }
    if (talhaoAnterior?.areaDisponivelPorcentagem <= 0 && !isNewGroup) {
      return false;
    }
    if (talhaoAnterior?.areaDisponivelPorcentagem < 100 && !isNewGroup) {
      return false;
    }
    if (talhaoAnterior?.areaDisponivelPorcentagem >= 100 && !isNewGroup) {
      return true;
    }
    if (operacao.areaDisponivelPorcentagem <= 0) {
      return true;
    }
    if (index === 0 && operacao.status !== "Executada") {
      return false;
    }
    if (index !== 0 && isNewGroup && operacao.status !== "Executada") {
      return false;
    }
    if (talhaoAnterior && talhaoAnterior?.status !== "Executada" && talhaoAnterior?.status !== "ExecutadaParcialmente") {
      return true;
    }
    if (operacao.status === "Executada") {
      return true;
    }
    if (!operacao.operacaoClasse) {
      return true;
    }
    return false;
  }

  export function isNewGroup(operacao: string, index: number, arr: any[]): boolean {
    if (index === 0) return false;
    return operacao !== arr[index - 1].operacaoClasse;
  }